import {
    getUserFromStorage,
    Layout,
    LayoutContainer,
    MessageComposerStandardButton,
    Text,
} from "@relode/core";
import * as React from "react";
import styled from "styled-components";

import InComp from "./images/market_research_compensation.png";
import InDemand from "./images/market_research_demand.png";
import InDiversity from "./images/market_research_diversity.png";
import InSummary from "./images/market_research_summary.png";
import InSupply from "./images/market_research_supply.png";
import { JobMarketResearchMarketingProps } from "./jobMarketResearchMarketing";

const MarketingSection = styled.div`
    margin: auto;
`;

const MarketingFooter = styled.div`
    margin: 64px auto 64px auto;
`;

const MarketingCta = styled.div`
    width: 100%;
    margin: 16px 0;
    display: flex;
    justify-content: center;
`;

export const JobMarketResearchMarketingMobile = (
    props: JobMarketResearchMarketingProps
) => {
    const { job } = props;
    const authenticatedUser = getUserFromStorage();

    return (
        <>
            <Text variant="h2">market research</Text>
            <LayoutContainer>
                <Layout mode="50/50" gapSize="large">
                    <MarketingSection>
                        <Text variant="h2" gutterBottom>
                            labor market research for all your jobs
                        </Text>
                        <Text variant="body1">
                            You need all of the facts when hiring. Our labor market
                            research helps you understand the current compensation,
                            supply, demand, and diversity for your position. Plan
                            better. Hire better. Contact your Relode account
                            executive for details.
                        </Text>
                        <MarketingCta>
                            <MessageComposerStandardButton
                                color="primary"
                                title="contact relode"
                                leadId={authenticatedUser.userId}
                                leadName={authenticatedUser.displayName}
                                // eslint-disable-next-line max-len
                                initialBodyText="I'd like to learn more about Relode market research and how it could help my organization. Thanks!"
                                initialRecipients={[
                                    {
                                        userId: job.details.jobManager.userId,
                                        displayName:
                                            job.details.jobManager.fullName,
                                        roleName: job.details.jobManager.roleName,
                                    },
                                ]}
                            />
                        </MarketingCta>
                    </MarketingSection>
                    <MarketingSection>
                        <img src={InSummary} width="100%" />
                    </MarketingSection>
                    <MarketingSection>
                        <Text variant="h2" gutterBottom>
                            compensation
                        </Text>
                        <Text variant="body1">
                            See how your job's salary compares to regional and
                            national percentiles. Use this market research for
                            budgeting and reaching your addressable talent market.
                        </Text>
                    </MarketingSection>
                    <MarketingSection>
                        <img src={InComp} width="100%" />
                    </MarketingSection>

                    <MarketingSection>
                        <Text variant="h2" gutterBottom>
                            supply
                        </Text>
                        <Text variant="body1">
                            Understand regional/national talent availability using
                            public, self-reported information about individuals' job
                            history and skills. Make informed decisions regarding
                            relocation, remote workers, and job marketing.
                        </Text>
                    </MarketingSection>
                    <MarketingSection>
                        <img src={InSupply} width="100%" />
                    </MarketingSection>
                    <MarketingSection>
                        <Text variant="h2" gutterBottom>
                            demand
                        </Text>
                        <Text variant="body1">
                            Gain an accurate view of the competitive landscape for
                            talent from job posting data updated nightly. Set
                            realistic expectations for talent acquisition based on
                            the current job market.
                        </Text>
                    </MarketingSection>
                    <MarketingSection>
                        <img src={InDemand} width="100%" />
                    </MarketingSection>

                    <MarketingSection>
                        <Text variant="h2" gutterBottom>
                            diversity
                        </Text>
                        <Text variant="body1">
                            Explore talent pools based on age, race/ethnicity, and
                            gender for every occupation and industry anywhere in the
                            US. Set achievable diversity goals for your organization
                            with this data.
                        </Text>
                    </MarketingSection>
                    <MarketingSection>
                        <img src={InDiversity} width="100%" />
                    </MarketingSection>
                </Layout>
                <Layout mode="100" gapSize="large">
                    <MarketingFooter>
                        <Text variant="h2" gutterBottom>
                            ready to hire smarter?
                        </Text>
                        <MarketingCta>
                            <MessageComposerStandardButton
                                color="primary"
                                title="contact relode"
                                leadId={authenticatedUser.userId}
                                leadName={authenticatedUser.displayName}
                                // eslint-disable-next-line max-len
                                initialBodyText="I'd like to learn more about Relode market research and how it could help my organization. Thanks!"
                                initialRecipients={[
                                    {
                                        userId: job.details.jobManager.userId,
                                        displayName:
                                            job.details.jobManager.fullName,
                                        roleName: job.details.jobManager.roleName,
                                    },
                                ]}
                            />
                        </MarketingCta>
                    </MarketingFooter>
                </Layout>
            </LayoutContainer>
        </>
    );
};
